import { UnifiedAlarm } from '@hakimo-ui/hakimo/types';

const COLOR_CRITICAL = 'bg-orange-300';
const COLOR_CRITICAL_BORDER = 'border-r border-orange-200 bg-orange-300';
const COLOR_MINOR = 'border-r border-green-200 bg-green-300';
const COLOR_INFO = 'border-r border-gray-400 bg-gray-400';
// const COLOR_DEDUP = 'bg-status-teal';

function videoAlarmColor(
  tap: number | undefined,
  resolvedAlarm?: boolean
): string {
  if (resolvedAlarm) return COLOR_MINOR;
  if (tap == null) return COLOR_CRITICAL_BORDER;
  if (tap > 50) return COLOR_CRITICAL;
  if (tap === 39 || tap === 50) return COLOR_MINOR;
  if (tap >= 40 && tap < 50) return COLOR_INFO;
  return COLOR_CRITICAL_BORDER;
}

function frameAlarmColor(alarm: UnifiedAlarm): string {
  // if (alarm.isPastEvent) return COLOR_INFO;
  // if (alarm.isDedupEvent) return COLOR_DEDUP;
  if (alarm.severity === 'high') return COLOR_CRITICAL;
  if (alarm.severity === 'low') return COLOR_MINOR;
  return COLOR_CRITICAL_BORDER;
}

export function alarmColor(alarm: UnifiedAlarm): string {
  switch (alarm.media.type) {
    case 'video':
      return videoAlarmColor(alarm.tap, alarm.resolvedAlarm);
    case 'frames':
      return frameAlarmColor(alarm);
    default:
      return COLOR_CRITICAL_BORDER;
  }
}
